export const blockIconsFileDownloading = (
	<span className='material-symbols-outlined'>downloading</span>
);
